/* Ashario Pets — collection page interactions
   - Open/close mobile filter drawer
   - Auto-submit filters on checkbox change (desktop only)
   - Auto-submit sort on change
   - Debounced submit on price-range input */

(function () {
  "use strict";

  // Bind to EVERY [data-ap-coll] root on the page (collection page +
  // homepage shop-all + any custom AP grid section). Each gets its own
  // drawer + filter handlers.
  const roots = document.querySelectorAll("[data-ap-coll]");
  if (!roots.length) return;

  const isDesktop = () => matchMedia("(min-width: 990px)").matches;

  roots.forEach((root) => {
    // ---------------------------------------------------------------
    // Mobile filter drawer
    // ---------------------------------------------------------------
    const openButtons = root.querySelectorAll("[data-ap-open-filter]");
    const closeButtons = root.querySelectorAll("[data-ap-close-filter]");
    const backdrop = root.querySelector("[data-ap-coll-backdrop]");

    const openDrawer = () => {
      root.classList.add("ap-coll--filter-open");
      document.documentElement.style.overflow = "hidden";
    };
    const closeDrawer = () => {
      root.classList.remove("ap-coll--filter-open");
      document.documentElement.style.overflow = "";
    };

    openButtons.forEach((b) => b.addEventListener("click", openDrawer));
    closeButtons.forEach((b) => b.addEventListener("click", closeDrawer));
    if (backdrop) backdrop.addEventListener("click", closeDrawer);

    // ---------------------------------------------------------------
    // Filter form auto-submit — handles BOTH the collection page form
    // (#ap-coll-filter-form) and the homepage shop-all form
    // (#ap-shop-all-filter-form). Treats every form input inside
    // .ap-coll__filters as a filter input regardless of marker, so it
    // works even if [data-ap-filter-input] is missing.
    // ---------------------------------------------------------------
    const filterForm =
      root.querySelector(".ap-coll__filters") ||
      root.querySelector("#ap-coll-filter-form") ||
      root.querySelector("#ap-shop-all-filter-form");
    if (filterForm) {
      let priceTimeout;
      filterForm.addEventListener("change", (e) => {
        const input = e.target.closest('input, select');
        if (!input) return;
        // Skip sort dropdown — handled separately
        if (input.matches("[data-ap-sort], select.ap-coll__sort")) return;
        // Only auto-submit on desktop; mobile waits for "Apply"
        if (!isDesktop()) return;
        if (input.type === "number") {
          clearTimeout(priceTimeout);
          priceTimeout = setTimeout(() => filterForm.submit(), 600);
        } else {
          filterForm.submit();
        }
      });
      // Debounced number input on desktop
      filterForm.addEventListener("input", (e) => {
        const input = e.target.closest('input[type="number"]');
        if (!input) return;
        if (!isDesktop()) return;
        clearTimeout(priceTimeout);
        priceTimeout = setTimeout(() => filterForm.submit(), 700);
      });
    }

    // ---------------------------------------------------------------
    // Sort: submit on change. On the collection page we preserve the
    // current URL's filter params; on the homepage the form action is
    // the collection URL so we just submit it (full navigation).
    // ---------------------------------------------------------------
    const sortForm = root.querySelector("[data-ap-sort-form], .ap-coll__sort-form");
    const sortSelect = root.querySelector("[data-ap-sort], select.ap-coll__sort");
    if (sortForm && sortSelect) {
      sortSelect.addEventListener("change", () => {
        // If we're already on the collection (URL pathname matches the
        // form action), preserve filter params. Otherwise submit the
        // form as-is so it navigates with the new sort.
        try {
          const action = new URL(sortForm.action, window.location.href);
          if (action.pathname === window.location.pathname) {
            const params = new URLSearchParams(window.location.search);
            params.set("sort_by", sortSelect.value);
            params.delete("page");
            window.location.search = params.toString();
            return;
          }
        } catch (_) {}
        sortForm.submit();
      });
    }
  });

  // Global Escape closes any open filter drawer
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    document.querySelectorAll(".ap-coll--filter-open").forEach((r) => {
      r.classList.remove("ap-coll--filter-open");
    });
    document.documentElement.style.overflow = "";
  });
})();
